module.exports = __webpack_public_path__ + "img/786-f6cdc4.png";